import IPage from "../../../interfaces/page";
import LoginFormComponent from "../../Components/LoginForm/LoginForm.component";
import PublicLayout from "../../layouts/Public/Public.layout";

const LoginPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <PublicLayout component={LoginFormComponent} />
}

export default LoginPage;